<template>
  <div>




<h2 class="goth" ref="gramtitel">Adjektivets komparation</h2>
<div class="grammatikparagrafbredd leftorient">

    <h4>Regelbunden komparation</h4>

    <p>Regelbundna adjektiv komparerats som exemplet i tabellen</p>
    <table class="">

        <tr class="leftorient">

            <td class="ljusgra">positiv</td>
            <td class="ljusgra">komparativ</td>
            <td class="ljusgra">superlativ</td>
        </tr>

        <tr class="leftorient">

            <td class="vit">schnell</td>
            <td class="vit">schnell<b>er</b></td>
            <td class="vit">am schnell<b>sten</b><br>der (das, die) schnell<b>ste</b></td>

        </tr>
</table>

<br><p>När adjektivet står som predikatsfyllnad (efter sitt substantiv) kan båda varianterna av superlativ användas, men står adjektivet
    som attribut (före sitt substantiv) kan bara den andra varianten användas:</p>


<b>Predikatsfyllnad</b>
<div class="ruta">
    <p><i>Der Gepard ist <b>am</b> schnell<b>sten</b> / der schnell<b>ste</b><br>
    Geparden är snabbast.</i></p>
</div>
<br>
    <b>Attribut</b>
        <div class="ruta">
        <p><i>Der Gepard ist das schnell<b>ste</b> Tier<br>
        Geparden är det snabbaste djuret.</i></p>
</div>

<br><p>Ibland skjuts <b>-e-</b> in för uttalets skull</p>

<table class="">

    <tr class="leftorient">

        <td class="ljusgra">positiv</td>
        <td class="ljusgra">komparativ</td>
        <td class="ljusgra">superlativ</td>
    </tr>

    <tr class="leftorient">

        <td class="vit">nett</td>
        <td class="vit">nett<b>er</b></td>
        <td class="vit">am nett<b><div class="accented">e</div>sten</b><br>der (das, die) nett<b><div class="accented">e</div>ste</b></td>

    </tr>

</table>
<p>Det gäller de flesta adjektiv som slutar på <i>-d, -t, -sch, -s</i> eller <i>-z</i>.</p>

<br><p>Ibland försvinner istället ett <b>e</b> från stammen i komparativ.</p>

<table class="">

    <tr class="leftorient">

        <td class="ljusgra">positiv</td>
        <td class="ljusgra">komparativ</td>
        <td class="ljusgra">superlativ</td>
    </tr>

    <tr class="leftorient">
        <td class="vit">teuer</td>
        <td class="vit">te<u>ur</u><b>er</b></td>
        <td class="vit">am tuer<b>sten</b><br>der (das, die) teuer<b>ste</b></td>
    </tr>

    <tr class="leftorient">
        <td class="vit">dunkel</td>
        <td class="vit">dun<u>kl</u><b>er</b></td>
        <td class="vit">am dunkel<b>sten</b><br>der (das, die) dunkel<b>ste</b></td>
    </tr>


</table>
<p>Det gäller ofta adjektiv som slutar på <i>-el, -en</i> eller <i>-er</i>.</p>


<br><h4>Några adjektiv får omljud</h4>

<p>Det gäller ett fåtal men mycket vanliga adjektiv. T.ex:</p>

<table class="parvis">

    <tr class="leftorient">

        <td class="ljusgra">positiv</td>
        <td class="ljusgra">komparativ</td>
        <td class="ljusgra">superlativ</td>
    </tr>

    <tr class="leftorient">
        <td class="vit">jung</td>
        <td class="vit">j<div class="accented"><b>ü</b></div>ng<b>er</b></td>
        <td class="vit">am j<div class="accented"><b>ü</b></div>ng<b>sten</b>
            <br>der (das, die) j<div class="accented"><b>ü</b></div>ng<b>ste</b></td>
    </tr>

    <tr class="leftorient">
        <td class="vit">alt</td>
        <td class="vit"><div class="accented"><b>ä</b></div>lt<b>er</b></td>
        <td class="vit">am <b><div class="accented">ä</div></b>lte<b>sten</b>
            <br>der (das, die) <div class="accented"><b>ä</b></div>lte<b>ste</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">kalt</td>
        <td class="ljusgra">k<div class="accented"><b>ä</b></div>lt<b>er</b></td>
        <td class="ljusgra">am k<b>ä</b>lte<b>sten</b><br>der (das, die) k<div class="accented"><b>ä</b></div>lte<b>ste</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">varm</td>
        <td class="ljusgra">v<div class="accented"><b>ä</b></div>rm<b>er</b></td>
        <td class="ljusgra">am v<div class="accented"><b>ä</b></div>rm<b>sten</b><br>der (das, die) v<div class="accented"><b>ä</b></div>rm<b>ste</b></td>
    </tr>

    <tr class="leftorient">
        <td class="vit">schwach</td>
        <td class="vit">schw<div class="accented"><b>ä</b></div>ch<b>er</b></td>
        <td class="vit">am schw<div class="accented"><b>ä</b></div>ch<b>sten</b><br>der (das, die) schw<div class="accented"><b>ä</b></div>ch<b>ste</b></td>
    </tr>

    <tr class="leftorient">
        <td class="vit">stark</td>
        <td class="vit">st<div class="accented"><b>ä</b></div>rk<b>er</b></td>
        <td class="vit">am st<div class="accented"><b>ä</b></div>rk<b>sten</b><br>der (das, die) st<div class="accented"><b>ä</b></div>rk<b>ste</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">lang</td>
        <td class="ljusgra">l<div class="accented"><b>ä</b></div>ng<b>er</b></td>
        <td class="ljusgra">am l<div class="accented"><b>ä</b></div>ng<b>sten</b><br>der (das, die) l<div class="accented"><b>ä</b></div>ng<b>ste</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">kurz</td>
        <td class="ljusgra">k<div class="accented"><b>ü</b></div>rz<b>er</b></td>
        <td class="ljusgra">am k<div class="accented"><b>ü</b></div>rze<b>sten</b>
            <br>der (das, die) k<div class="accented"><b>ü</b></div>rze<b>ste</b></td>
    </tr>



</table>


<br><br><h4>Oregelbunden komparation</h4>

<p>Följande adjektiv har oregelbunden komparation:</p>

<table class=" parvis">

    <tr class="leftorient">

        <td class="ljusgra">positiv</td>
        <td class="ljusgra">komparativ</td>
        <td class="ljusgra">superlativ</td>
    </tr>

    <tr class="leftorient">
        <td class="vit">gut</td>
        <td class="vit">besser</td>
        <td class="vit">am besten<br>der (das, die) beste</td>
    </tr>

    <tr class="leftorient">
        <td class="vit">hoch</td>
        <td class="vit">höher</td>
        <td class="vit">am höchsten<br>der (das, die) höchste</td>
    </tr>

    <tr class="leftorient">
        <td class="vit">nah</td>
        <td class="vit">näher</td>
        <td class="vit">am nächsten<br>der (das, die) nächste</td>
    </tr>


    <tr class="leftorient">
        <td class="vit">viel</td>
        <td class="vit">mehr</td>
        <td class="vit">am meisten<br>der (das, die) meisten</td>
    </tr>

</table>
<br>

<br><h4>Använd inte <i>mer</i> och <i>mest</i></h4>
<p>På svenska unviker man att komparera långa adjektiv med ändelser och
    använder istället orden <i>mer</i> och <i>mest</i> framför adjektiven i komparativ och superlativ.</p>

<p> t.ex. instället för <i><strike>intressant, intressantare, intressantast</strike></i> används <i>intressant, <b>mer</b> intressant, <b>mest</b> intressant</i>.</p>

<p>På tyskan kompareras dock alla adjektiv med ändelser oavsett deras längd:</p>

<p> <i>interessant, interessant<b>er</b>, am interessant<b>esten</b></i></p>

</div>

</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "adjektiv komparation böjning"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vit {
    background-color: #eee;
}
</style>
